import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  rounded?: boolean
  small?: boolean
  medium?: boolean
  large?: boolean
  icon?: boolean
  error?: string
  disabled?: boolean
}

export const Input = styled.input`
  position: ${(props: IStyleProps) => (props.icon ? 'relative' : 'inherit')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  font-family: 'Inter';
  box-sizing: border-box;
  padding: 12px;
  margin-left: 0.5px;
  transition: all 0.3s ease-out;
  height: 44px;
  outline: none;
  color: #424242;
  background: ${(props) =>
    props.disabled ? '#EEEEEE' : Theme.pallete.SECONDARY};
  border: 1px solid;
  border-color: ${(props) =>
    props.disabled
      ? Theme.pallete.QUATERNARY
      : props.error
      ? '#D61212'
      : '#cccccc'};
  &:hover {
    border-color: ${(props) =>
      props.disabled
        ? Theme.pallete.QUATERNARY
        : props.error
        ? '#B00000'
        : '#757575'};
  }
  &:disabled {
    color: rgb(84, 84, 84);
  }
  border-radius: ${(props: IStyleProps) => (props.rounded ? '30px' : '5px')};
  width: 100%;
  max-width: 100%;
`

export const Error = styled.p`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: ${Theme.pallete.SENARY};
  margin-top: 10px;
`

export const InputError = styled.div`
  font-family: ${Theme.fontFamily.SECONDARY};
  position: absolute;
  bottom: -3px;
  transform: translateY(100%);
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: start;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${Theme.pallete.SENARY};
`
